import axios from "axios";
import { IReviewPayload } from "../../utility/types/reviewType";
import { API_BASE_URL } from "../../axiosConfig/apiUrl";

export const submitCreateReview = async (payload: IReviewPayload) => {
  try {
    const response = await axios.post(
      `${API_BASE_URL}/review`,
      { payload },
      { withCredentials: true }
    );

    return response.data.review;
  } catch (error: any) {
    if (error.response && error.response.data.message) {
      throw new Error(error.response.data.message);
    } else {
      throw new Error("Unknown Error Occurred While Making Request To API");
    }
  }
};

export const submitGetUserReview = async (userId: string) => {
  try {
    const response = await axios.get(`${API_BASE_URL}/review/user/${userId}`, {
      withCredentials: true,
    });
    return response.data.reviews[0];
  } catch (error: any) {
    if (error.response && error.response.data.message) {
      throw new Error(error.response.data.message);
    } else {
      throw new Error("Unknown Error Occurred While Making Request To API");
    }
  }
};

export const submitGetAllReviews = async () => {
  try {
    const response = await axios.get(`${API_BASE_URL}/reviews`);

    return response.data.reviews;
  } catch (error: any) {
    if (error.response && error.response.data.message) {
      throw new Error(error.response.data.message);
    } else {
      throw new Error("Unknown Error Occurred While Making Request To API");
    }
  }
};
